import ApiService from "@/core/services/api.service";

// action types
export const GET_ORDERS_STAT = "getOrdersStat";
export const GET_QUANTITY = "getQuantity";


// mutation types
export const SET_ORDERS_STAT = "setOrdersStat";
export const SET_QUANTITY = "setQuantity";
export const SET_ORDERS_ERROR = "setOrderErrors";


const state = {
    errors: {},
    ordersStat: [],

    quantity:{
        orders: '',
        clients: '',
        products: '',
    },


};

const getters = {
    gettersOrdersStat(state) {
        return state.ordersStat;
    },

    gettersQuantity(state) {
        return state.quantity;
    },

};

const actions = {

    [GET_ORDERS_STAT](context) {
        return new Promise((resolve, reject) => {
            ApiService.get("/orders-stat")
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_ORDERS_STAT, data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },


    [GET_QUANTITY](context) {
        return new Promise((resolve, reject) => {
            ApiService.get("/quantity")
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_QUANTITY, data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

};

const mutations = {
    [SET_ORDERS_ERROR](state, error) {
        state.errors = error;
    },

    [SET_ORDERS_STAT](state, data) {
        state.ordersStat = data.statistics;

    },

    [SET_QUANTITY](state, data) {
        state.quantity.orders = data.orders;
        state.quantity.clients = data.clients;
        state.quantity.products = data.products;

    },


};

export default {
    state,
    actions,
    mutations,
    getters
};
